import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import DownArrow from '../../../../assets/pdp/downArrowWithCircle.svg';
import FlexBox from '@/atomic-components/FlexBox';
import { getStyle } from '@/utils/theme/fonts';
import { getColor } from '@/utils/theme/colors';
import { useState } from 'react';

function NCemiTiles(props: any) {
	const [showFullData, setShowFullData] = useState(false);
	return (
		<>
			<FlexBox
				sx={{
					justifyContent: 'space-between',
					padding: '8px',
					borderTop: `1px solid ${getColor('Gray -5')}`,
					borderBottom: !showFullData
						? `1px solid ${getColor('Gray -5')}`
						: 'none',
				}}
			>
				<LencoTypography sx={{ ...getStyle('P_Medium'), color: getColor('Gray 0') }}>
					{props.bankName}
				</LencoTypography>
				<Box
					onClick={() => setShowFullData(!showFullData)}
					sx={{
						transform: showFullData ? 'rotate(180deg)' : 'rotate(0deg)',
						cursor: 'pointer',
					}}
				>
					<DownArrow />
				</Box>
			</FlexBox>
			{showFullData && (
				<Box sx={{ margin: '8px 0' }}>
					<FlexBox
						sx={{
							justifyContent: 'space-between',
							padding: '16px',
							background: getColor('Minty -5'),
							borderRadius: '16px 16px 0 0 ',
						}}
					>
						{['Months', 'Interest', 'Monthly EMI', 'Overall Cost'].map(
							(data) => {
								return (
									<Box
										key={data}
										sx={{
											textAlign: 'center',
											...getStyle('Small_Medium'),
											color: getColor('Gray 0'),
										}}
									>
										{data}
									</Box>
								);
							}
						)}
					</FlexBox>
					<Box sx={{ margin: '0 16px 16px 16px' }}>
						{props.emiDetails.map((data: any, index: number) => {
							return (
								<FlexBox
									key={index}
									sx={{
										justifyContent: 'space-between',
										padding: '8px 0',
										borderTop:
											index == 0 ? 'none' : `1px solid ${getColor('Gray -5')}`,
										borderBottom:
											index == props.emiDetails.length - 1
												? 'none'
												: `1px solid ${getColor('Gray -5')}`,
									}}
								>
									<LencoTypography
										sx={{
											...getStyle('Small_Medium'),
											color: getColor('Gray 0'),
										}}
									>
										{data.month}
									</LencoTypography>
									<LencoTypography
										sx={{
											...getStyle('Small_Medium'),
											color: getColor('Gray 0'),
										}}
									>
										{data.interest}
									</LencoTypography>
									<LencoTypography
										sx={{
											...getStyle('Small_Medium'),
											color: getColor('Gray 0'),
										}}
									>
										{data.monthlyEmi}
									</LencoTypography>
									<LencoTypography
										sx={{
											...getStyle('Small_Medium'),
											color: getColor('Gray 0'),
										}}
									>
										{data.overallCost}
									</LencoTypography>
								</FlexBox>
							);
						})}
					</Box>
				</Box>
			)}
		</>
	);
}

export default NCemiTiles;
